import { render, staticRenderFns } from "./UploadImageOriDialog.vue?vue&type=template&id=9fabffc2&scoped=true"
import script from "./UploadImageOriDialog.vue?vue&type=script&lang=js"
export * from "./UploadImageOriDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadImageOriDialog.vue?vue&type=style&index=0&id=9fabffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fabffc2",
  null
  
)

export default component.exports